import services from '../../../api/services';
import { logError } from 'util/errors';
import {
  GET_COMMENTS_REQUEST,
  GET_COMMENTS_SUCCESS,
  GET_COMMENTS_FAILURE,
  GET_RESPONSE_COMMENTS_REQUEST,
  GET_RESPONSE_COMMENTS_SUCCESS,
  GET_RESPONSE_COMMENTS_FAILURE,
  INIT_POST_COMMENT,
  POST_COMMENT_REQUEST,
  POST_COMMENT_SUCCESS,
  POST_COMMENT_FAILURE,
  INIT_COMMENT_ARCHIVE,
  PUT_ARCHIVE_COMMENT_REQUEST,
  PUT_ARCHIVE_COMMENT_SUCCESS,
  PUT_ARCHIVE_COMMENT_FAILURE,
  INIT_COMMENT_REPORT,
  POST_COMMENT_REPORT_REQUEST,
  POST_COMMENT_REPORT_SUCCESS,
  POST_COMMENT_REPORT_FAILURE,
} from './constants';

const { CommentService } = services;

export const getRootComments = (testId, contestId) => async (dispatch) => {
  try {
    dispatch({ type: GET_COMMENTS_REQUEST });
    let response;
    if (testId) {
      response = await CommentService.getComments('testId', testId);
    } else if (contestId) {
      response = await CommentService.getComments('contestId', contestId);
    }
    dispatch({ type: GET_COMMENTS_SUCCESS, comments: response.comments, testId, contestId });
  } catch (ex) {
    logError(ex);
    dispatch({ type: GET_COMMENTS_FAILURE, error: ex.message });
  }
};

export const getResponseComments = (parentId) => async (dispatch) => {
  try {
    dispatch({ type: GET_RESPONSE_COMMENTS_REQUEST, parentId });
    const response = await CommentService.getComments('respondsTo', parentId);
    dispatch({ type: GET_RESPONSE_COMMENTS_SUCCESS, parentId, comments: response.comments });
  } catch (ex) {
    logError(ex);
    dispatch({ type: GET_RESPONSE_COMMENTS_FAILURE, parentId, error: ex.message });
  }
};

export const initPostComment = (respondsTo) => async (dispatch) => {
  dispatch({ type: INIT_POST_COMMENT, respondsTo });
};

export const postComment = (text, testId, contestId, respondsTo) => async (dispatch) => {
  try {
    dispatch({ type: POST_COMMENT_REQUEST, respondsTo });
    const comment = await CommentService.createComment({ text, testId, contestId, respondsTo });
    dispatch({ type: POST_COMMENT_SUCCESS, comment });
  } catch (ex) {
    logError(ex);
    dispatch({ type: POST_COMMENT_FAILURE, error: ex.message, respondsTo });
  }
};

export const initArchiveComment = () => (dispatch) => {
  dispatch({ type: INIT_COMMENT_ARCHIVE });
};

export const archiveComment = (id) => async (dispatch) => {
  try {
    dispatch({ type: PUT_ARCHIVE_COMMENT_REQUEST });
    let archivedComment = await CommentService.archiveComment(id);
    dispatch({ type: PUT_ARCHIVE_COMMENT_SUCCESS, archivedComment });
  } catch (ex) {
    logError(ex);
    dispatch({ type: PUT_ARCHIVE_COMMENT_FAILURE, error: ex.message });
  }
};

export const initReportComment = () => (dispatch) => {
  dispatch({ type: INIT_COMMENT_REPORT });
};

export const reportComment = (commentId, feedback) => async (dispatch) => {
  try {
    dispatch({ type: POST_COMMENT_REPORT_REQUEST });
    await CommentService.reportComment({
      comment: commentId,
      feedback: feedback,
    });
    dispatch({ type: POST_COMMENT_REPORT_SUCCESS, result: 'Comment has been reported' });
  } catch (ex) {
    logError(ex);
    dispatch({ type: POST_COMMENT_REPORT_FAILURE, error: ex.message });
  }
};
